import React from 'react';
import { motion } from 'framer-motion';
import { Heart, ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Card, CardContent, CardFooter } from './ui/card';

const ProductCard = ({ product, onAddToCart, onQuickView }) => {
  const [isWishlisted, setIsWishlisted] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);

  const handleWishlist = () => {
    setIsWishlisted(!isWishlisted);
  };

  const discountPercentage = product.discountPercentage || 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <Card className="overflow-hidden group border border-border hover:shadow-lg transition-shadow">
        <div className="relative aspect-[3/4] overflow-hidden bg-muted">
          {/* Product Image */}
          <img
            src={product.image}
            alt={product.title}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
          />

          {/* Badges */}
          <div className="absolute top-2 left-2 flex flex-col gap-2">
            {product.isNew && (
              <Badge className="bg-primary text-primary-foreground">
                Nuevo
              </Badge>
            )}
          </div>

          {discountPercentage > 0 && (
            <Badge className="absolute top-2 right-2 bg-accent text-accent-foreground font-bold">
              -{discountPercentage}%
            </Badge>
          )}

          {/* Wishlist Button */}
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-2 right-2 bg-white/80 hover:bg-white"
            onClick={handleWishlist}
          >
            <Heart
              className={`w-4 h-4 ${
                isWishlisted ? 'fill-destructive text-destructive' : ''
              }`}
            />
          </Button>

          {/* Quick View Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{
              opacity: isHovered ? 1 : 0,
              y: isHovered ? 0 : 20
            }}
            className="absolute bottom-2 left-2 right-2"
          >
            <Button
              variant="secondary"
              className="w-full"
              onClick={() => onQuickView(product)}
            >
              Vista rápida
            </Button>
          </motion.div>
        </div>

        <CardContent className="p-4">
          <h3 className="font-medium text-sm line-clamp-2 mb-2">
            {product.title}
          </h3>
          <div className="flex items-center gap-2">
            {product.discountPrice ? (
              <>
                <span className="text-lg font-bold text-primary">
                  €{product.discountPrice.toFixed(2)}
                </span>
                <span className="text-sm text-muted-foreground line-through">
                  €{product.price.toFixed(2)}
                </span>
              </>
            ) : (
              <span className="text-lg font-bold text-primary">
                €{product.price.toFixed(2)}
              </span>
            )}
          </div>
        </CardContent>

        <CardFooter className="p-4 pt-0">
          <Button
            className="w-full gap-2"
            onClick={() => onAddToCart(product)}
          >
            <ShoppingCart className="w-4 h-4" />
            Añadir al carrito
          </Button>
        </CardFooter>
      </Card>
    </motion.div>
  );
};

export default ProductCard;